<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter" id="loi">
<h1 class="ctfm"><a class="page" id="pviii"></a><a class="page" id="pix"></a><a class="xref" href="#/haldipur0006#toc">List of Figures</a></h1>
<p class="toc">Figure I.1: The 40th, 42nd, and 44th Precincts of the New York Police Department</p>
<p class="toc">Figure I.2: 161st Street near the Bronx Hall of Justice</p>
<p class="toc">Figure I.3: 138th Street in the 40th Precinct</p>
<p class="toc">Figure I.4: New York City murders, 2002–2016</p>
<p class="toc">Figure I.5: NYPD stop and frisks, 2002–2016</p>
<p class="toc">Figure 1.1: Two boys play basketball using a makeshift hoop</p>
<p class="toc">Figure 3.1: A mother and her child attempt to beat the summer heat</p>
<p class="toc">Figure 4.1: A neighborhood corner store</p>
<p class="toc">Figure 4.2: A group of men play dominoes on the sidewalk</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// haldipur-0007.vue?547e23d8